import { useDirection } from "@/components/ui/direction";
import { cn } from "@/lib/utils";
import { type LucideIcon } from "lucide-react";

export function isHorizontalArrow(name: string): boolean {
  return /left|right|sendhorizontal/i.test(name);
}

interface DirectionalIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  icon: LucideIcon;
}

function DirectionalIcon({
  icon: Icon,
  className,
  ...props
}: DirectionalIconProps) {
  const direction = useDirection();
  const iconName = Icon.displayName ?? Icon.name ?? "";

  return (
    <span
      className={cn(
        "inline-flex",
        direction === "rtl" && isHorizontalArrow(iconName) && "scale-x-[-1]",
        className,
      )}
      {...props}
    >
      <Icon />
    </span>
  );
}

export { DirectionalIcon };
